import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import modalStyles from '@components-library/Modals/modalWrapper.styles.module.scss';
import ModalPortal from '@components-shared/modal/ModalPortal';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { IBrokerParams, LanguageType } from 'global.interfaces';
import styles from './styles.module.scss';

interface IProps {
  onCloseHandler: () => void;
  brokerParams: IBrokerParams;
}

const UserWelcomeModalComponent: React.FC<IProps> = ({ onCloseHandler, brokerParams }) => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language as LanguageType;

  return (
    <ModalPortal>
      <div className={cn(modalStyles.formModal, styles.container)}>
        <div className={cn(modalStyles.formModalInner, styles.inner)}>
          <div className={cn(modalStyles.formModalTitle, styles.header)}>
            {i18n.t(keyMap.modalWelcomeTitle, {
              brokerName: brokerParams[currentLanguage]?.brokerName,
            })}
          </div>
          <div className={cn(modalStyles.formModalBody, styles.body)}>
            <p>{i18n.t(keyMap.modalWelcomeYourTradingJourneyStartsHere)}</p>
            <p>{i18n.t(keyMap.modalWelcomeGettingStarted)}</p>
            <ol>
              <li>{i18n.t(keyMap.commonDeposit)}</li>
              <li>{i18n.t(keyMap.modalWelcomeGetTradingApp)}</li>
              <li>{i18n.t(keyMap.commonTrade)}</li>
            </ol>
          </div>
          <div className={cn(modalStyles.formModalBody, styles.footer)}>
            <NavLink className="btn light--button" onClick={onCloseHandler} to="/member/profile">
              {i18n.t(keyMap.modalWelcomeCompleteProfile)}
            </NavLink>

            <NavLink className="btn" onClick={onCloseHandler} to="/member/psp/deposit">
              {i18n.t(keyMap.modalWelcomeDepositNow)}
            </NavLink>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export const UserWelcomeModal = React.memo(UserWelcomeModalComponent);
